import React from "react";
import {
  Battery, Plug, Wrench, Thermometer, Snowflake, Zap,
  Gauge, Activity, Cpu, Truck,
} from "lucide-react";
import { EV_SERVICES } from "@/data/content";
import { EV } from "@/constants/testIds";

const ICON_MAP = {
  "tesla-diagnostics": Cpu,
  "hv-battery": Battery,
  "charge-port": Plug,
  "ptc-heater": Thermometer,
  "hv-ac": Snowflake,
  "12v-battery": Zap,
  "brakes-suspension": Activity,
  "alignment": Gauge,
  "remapping": Wrench,
  "recovery": Truck,
};

export default function EvServices() {
  return (
    <section id="ev" data-testid={EV.section} className="section relative">
      <div className="container-owrs">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="overline mb-4">02 — The New EV Arm</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05]">
              Built around <br />
              <span className="text-[var(--owrs-accent)]">High Voltage.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-8">
            <p className="text-lg text-[var(--owrs-text-muted)] leading-relaxed">
              OWRS Automotive has made substantial investments in EV/hybrid powertrain
              equipment, tooling and IMI-certified training. Whether you drive a Tesla,
              Porsche Taycan, Audi e-tron, BMW i3 or any other electric or hybrid vehicle,
              we can look after it in-house. Every job is carried out by technicians fully
              certified in high-voltage safety and repair procedures.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--owrs-border)]">
          {EV_SERVICES.map((s, idx) => {
            const Icon = ICON_MAP[s.slug] || Wrench;
            return (
              <div
                key={s.slug}
                data-testid={EV.card(s.slug)}
                className="group relative p-8 sm:p-10 bg-[var(--owrs-bg)] hover:bg-[var(--owrs-surface)] transition-colors duration-500"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-12 w-12 inline-flex items-center justify-center border border-[var(--owrs-border-strong)] text-[var(--owrs-text)] group-hover:bg-[var(--owrs-accent)] group-hover:text-white group-hover:border-[var(--owrs-accent)] transition-colors">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-xs text-[var(--owrs-text-dim)] font-mono">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-medium tracking-tight mb-3 text-[var(--owrs-text)]">
                  {s.title}
                </h3>
                <p className="text-sm text-[var(--owrs-text-muted)] leading-relaxed">
                  {s.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-sm text-[var(--owrs-text-muted)]">
          <span className="text-[var(--owrs-accent)]">●</span> Remapping is available on{" "}
          <span className="text-[var(--owrs-text)]">selected EV makes and models</span> only —
          please get in touch to confirm yours.
        </div>
      </div>
    </section>
  );
}
